import { render, staticRenderFns } from "./FoodForm.vue?vue&type=template&id=0a4f9aca"
import script from "./FoodForm.vue?vue&type=script&lang=js"
export * from "./FoodForm.vue?vue&type=script&lang=js"
import style0 from "./FoodForm.vue?vue&type=style&index=0&id=0a4f9aca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports